import { z } from 'zod';
import { internalFeesServiceConfigSchema } from '../configurations/InternalFeesServiceConfig.js';
import { servicesProviderGenericDataSchema } from '../ServicesProviderData.js';
import { Services } from './Services.js';

const servicesProviderInternalFeesDataSchema = servicesProviderGenericDataSchema.extend({
    config: z.object({
        [Services.INTERNAL_FEES]: internalFeesServiceConfigSchema,
    }),
});

export { servicesProviderInternalFeesDataSchema };
//# sourceMappingURL=ServicesProviderInternalFeesData.js.map
